import React from 'react';

import {LogoIcon} from '../../../imports/icons';
import './mobileView.scss';

const MobileView = () => (
  <div className="mobile-view">
    <LogoIcon />
    <p className="mobile-message">
      We have noticed that you are using mobile device. Unfortunately, requested page is available for desktop browsers
      only at the moment. Please download mobile app to unlock each and every feature of Fireswan.
    </p>
    <div className="mobile-download">
      <a href="https://itunes.apple.com/us/app/fireswan/id1454166661?ls=1&amp;mt=8" className="mobile-download btn">
        <img
          src="https://uploads-ssl.webflow.com/5badf8471f2da2d796171ffc/5ca64db76d90330d33451390_download-app-store.svg"
          alt=""
        />
      </a>
      <a href="https://play.google.com/store/apps/details?id=com.fireswan&amp;hl=en" className="mobile-download btn">
        <img
          src="https://uploads-ssl.webflow.com/5badf8471f2da2d796171ffc/5ca64db74c3b21c35bb53c0d_download-google-play.svg"
          alt=""
        />
      </a>
    </div>
  </div>
);

export default MobileView;
